import { cn } from '@utils/cn';

import type { ProgressbarProps } from './Progressbar.types';

import { progressbarStepClasses, progressbarVariants } from './Progressbar.styles';

const Progressbar = ({ steps, activeStep, className, ...props }: ProgressbarProps) => {
  const getStepState = (index: number) => {
    if (index < activeStep) {
      return 'completed';
    }
    if (index === activeStep) {
      return 'current';
    }
    return 'next';
  };

  const getStepClasses = (index: number) => {
    const currentStep = index + 1;
    const state = getStepState(currentStep);

    return cn(progressbarStepClasses({ state }));
  };

  return (
    <div className={cn(progressbarVariants, className)} {...props}>
      {Array.from({ length: steps }, (_, index) => (
        <div key={index} className={getStepClasses(index)} />
      ))}
    </div>
  );
};

export { Progressbar };
